import AppContext from "PFApp/app_context";
import PageTabs from "PFComponents/page/page_tabs";
import fetchCurrentAccount from "PFCore/services/accounts/current_account";
import { CURRENT_ACCOUNT_ACTIONS } from "PFReducers/current_account_reducer";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import BookingCalendars from "./calendars/booking_calendars";
import BookingCategories from "./categories/booking_categories";
import BookingThresholds from "./thresholds/booking_thresholds";

const DEFAULT_SECTION = "categories";

const BookingConfigController = () => {
  const { dispatch } = useContext(AppContext);
  const { t } = useTranslation("bookingModule");
  const { section } = useParams();
  const history = useHistory();

  const [tab, setTab] = useState(section || DEFAULT_SECTION);

  useEffect(() => {
    if (!section) {
      history.replace(`/admin/booking/${DEFAULT_SECTION}`);
    }
    setTab(section || DEFAULT_SECTION);
  }, [section]);

  const tabs = [
    { id: "categories", displayElement: t("categories") },
    { id: "thresholds", displayElement: t("thresholds") },
    { id: "calendars", displayElement: t("calendars") }
  ];

  const TabComponent = {
    categories: BookingCategories,
    thresholds: BookingThresholds,
    calendars: BookingCalendars
  }[tab];

  const handleTabChange = (tab) => history.push(`/admin/booking/${tab.id}`);

  const refreshAccount = async () => {
    const account = await fetchCurrentAccount(dispatch);
    if (account) {
      dispatch({
        type: CURRENT_ACCOUNT_ACTIONS.CURRENT_ACCOUNT_READY,
        payload: account
      });
    }
  };

  return (
    <div>
      <h2>{t("config.title")}</h2>
      <PageTabs items={tabs} active={tab} handleClick={handleTabChange} />
      <TabComponent onConfigUpdate={refreshAccount} />
    </div>
  );
};

export default BookingConfigController;
